import tabs_module_default from "./tabs.module.js";
import { Tabs } from "@mantine/core";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/tabs/Tabs.tsx
/**
* Tabs allow users to switch between different views
*/
const Tabs$1 = ({ tabs, grow = false, defaultValue, onChange, value, keepMounted = true, tabBarProps, dataTestId, "data-testid": testId = dataTestId }) => {
	const fullBleedTabBar = !!tabBarProps?.fullBleed;
	const stickyTabBar = !!tabBarProps?.sticky;
	const gapBelowTabBar = !!tabBarProps?.gapBelow;
	const tabItems = tabs.map((item) => /* @__PURE__ */ jsx(Tabs.Tab, {
		value: item.value,
		disabled: item.disabled,
		leftSection: item.LeftIcon && /* @__PURE__ */ jsx(item.LeftIcon, {}),
		children: item.label
	}, item.value));
	const panelItems = tabs.map((item, idx) => /* @__PURE__ */ jsx(Tabs.Panel, {
		value: item.value,
		className: tabs_module_default.panel,
		children: item.panel
	}, `${item.value}-${idx}`));
	return /* @__PURE__ */ jsxs(Tabs, {
		classNames: tabs_module_default,
		"data-testid": testId,
		defaultValue,
		keepMounted,
		onChange,
		value,
		"data-full-bleed-tabbar": fullBleedTabBar,
		"data-sticky-tabbar": stickyTabBar,
		"data-single-item": tabs.length === 1,
		"data-gap-below-tabbar": gapBelowTabBar,
		children: [/* @__PURE__ */ jsx(Tabs.List, {
			grow,
			children: tabItems
		}), panelItems]
	});
};

//#endregion
export { Tabs$1 as Tabs };